
import {recentConstants} from '../_constants/Redux/footerActive'
export const activeFooter={
    addActiveFooter,
}

function addActiveFooter(data){
    return {type:recentConstants.ACTIVE_FOOTER,data}
}
